/*
 * @Description:
 * @Author: Leyton
 * @LastEditors: Leyton
 * @LastEditTime: 2022-06-10 10:37:16
 * @FilePath: /91qs_answer_frontpro/src/pages/questionnaire/js/answerType.js
 */
import MatrixCheckbox from "@/pages/checkbox/MatrixCheckbox";
import Drag from "@/pages/drag";
import SiglePageDrag from "@/pages/drag/SinglePageDrag";
import DragMatrixCheckbox from "@/pages/dragMatrix_checkbox";
import MatrixInput from "@/pages/input/MatrixInput";
import Matrix from "@/pages/matrix";
import Maxdiff from "@/pages/matrix/Maxdiff";
import MatrixRadio from "@/pages/radio/MatrixRadio";
import DoubleQuestionPhone from "@/pages/DoubleQuestion/DoubleQuestionPhone";

const isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);

// Radio   行单选
export const isMatrixRadioType = (optionForm, limit, pcH5Setting) => {
  if (limit === 2) return Maxdiff;
  console.log('====> ', isMobile, optionForm, pcH5Setting)
  if (isMobile) {
     
    switch (optionForm) {
      case 5:
      case 6:
        return Drag;
      case 7:
        return SiglePageDrag;
      case 8:
        return DoubleQuestionPhone;
      default:
        return MatrixRadio;
    }
  } else {
    switch (optionForm) {
      case 4:
        return pcH5Setting === 2 ? Matrix : MatrixRadio;
      case 5:
      case 6:
        return Drag;
      case 7:
        return SiglePageDrag;
      default:
        return Matrix;
    }
  }
};

// Checkbox  行多选
export const isMatrixCheckboxType = (optionForm, pcH5Setting) => {

  if (isMobile) {
    switch (optionForm) {
      case 5:
      case 6:
        return DragMatrixCheckbox;
      default:
        return MatrixCheckbox;
    }
  } else {
    switch (optionForm) {
      case 4:
        return pcH5Setting === 2 ? Matrix.Checkbox : MatrixCheckbox;
      case 5:
      case 6:
        return DragMatrixCheckbox;
      default:
        return Matrix.Checkbox;
    }
  }
};

// input
export const isMatrixInputype = (optionForm, pcH5Setting) => {
  switch (optionForm) {
    case 4:
      return pcH5Setting === 2 ? Matrix : MatrixInput;
    case 5:
    case 6:
      return Drag;
    default:
      return Matrix;
  }
};
